<template>
  <div class="paper-manage">
    <div class="paper-manage-header">
      <div class="title">专有词管理</div>
    </div>
    <div class="btn-wrapper">
      <div class="create-btn" @click="addLib">创建词库</div>
    </div>
    <List class="questionnaire-list" @flipPage="flipPage" :totalCount="totalCount" :currentPage="currentPageNo" :pageSize="10">
      <template v-slot:listContent>
        <div class="paper-list-content">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="name" label="词库名称" min-width="100"></el-table-column>
            <el-table-column prop="previewContent" label="专有词预览" min-width="150"> </el-table-column>
            <el-table-column prop="wordQuantity" label="专有词数量" min-width="50"> </el-table-column>
            <el-table-column label="操作" min-width="180">
              <template slot-scope="scope">
                <div class="option-button" @click="showWordList(scope.row)">查看词库</div>
                <div class="option-button" @click="editItem(scope.row)">批量修改</div>
                <div class="option-button" @click="deleteItem(scope.row)">删除词库</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </List>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <tip-dialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickConfirm="clickDeleteConfirm"></tip-dialog>
    <batch-edit-dialog ref="editDialog" :lib-id="editId" @saveSuccess="getManagerList"></batch-edit-dialog>
    <add-tip-dialog v-if="loaded" ref="addDialog" :dialogOptions="buildDialogOptions" @clickConfirm="clickBuildConfirm"></add-tip-dialog>
  </div>
</template>
<script>
import List from '@components/list/listFrame'
import AddTipDialog from '@components/common/AddTipDialog.vue'
import TipDialog from '../../common/TipDialog'
import compareVipRight from '@components/common/compareVipRight.js'
import api from '@api/specialWord'
import BatchEditDialog from '@components/SpecialWordManagement/components/BathEditDialog.vue'
export default {
  name: 'LibList',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      editId: '',
      deleteId: '',
      loaded: false,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确定删除，删除后不可恢复。'
      }
    }
  },
  computed: {
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.epaperClassifyNum}个报纸，创建更多需先升级会员服务。`
      }
    },
    buildDialogOptions() {
      return {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '创建专有词库',
        // 弹框内容
        label: '请输入专有词库名称：',
        value: '专有词库' + (this.totalCount + 1),
        message: '必须填写词库名称'
      }
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    getManagerList() {
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10
      }
      api.getSpecificWordLibByPage(param).then(async (res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.tableData = res.data.data.content
          this.totalCount = res.data.data.totalElements
        } else {
          this.tableData = []
        }
        this.loaded = true
      })
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getManagerList()
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0) {
        return 'text-align: center'
      }
    },
    addLib() {
      this.$refs.addDialog.visible = true
    },
    showWordList(item) {
      this.$emit('showWordList', item)
    },
    deleteItem(item) {
      this.deleteId = item.id
      this.$refs.deleteDialog.visible = true
    },
    clickDeleteConfirm() {
      let param = {
        id: this.deleteId
      }
      api.delSpecificWordLib(param).then((res) => {
        if (res.data.status === 0) {
          this.getManagerList()
        } else {
          this.$message({
            message: res.data.message || '删除失败',
            type: 'error'
          })
        }
      })
    },
    clickBuildConfirm(val) {
      const param = {
        name: val
      }
      api.addSpecificWordLib(param).then((res) => {
        if (res.data.status === 0) {
          this.getManagerList()
        } else {
          this.$message({
            message: res.data.message || '创建失败',
            type: 'error'
          })
        }
      })
    },
    editItem(item) {
      this.editId = item.id
      this.$refs.editDialog.visible = true
    },
    handleClick(val) {
      this.$refs.shareAllDialog.dialogVisible = false
      if (val === 1) {
        this.$refs.editShare.dialogVisible = true
      } else if (val === 2) {
        this.$refs.editShareContent.dialogVisible = true
      } else if (val === 3) {
        if (this.compare({ type: 'boole', key: 'displaySet' })) {
          this.$refs.buttonSet.dialogVisible = true
        } else {
          this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务。`
          this.$refs.memberDialog.visible = true
        }
      }
    }
  },
  async created() {
    await this.getManagerList()
  },
  components: {
    BatchEditDialog,
    AddTipDialog,
    TipDialog,
    List
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.paper-manage {
  width: 100%;
  height: 100%;
  .paper-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .btn-wrapper {
    display: flex;
    .create-btn {
      width: 140px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
      margin-left: 20px;
    }
  }
  a.updateContent {
    color: unset;
    text-decoration: none;
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
  .no-pointer-wrapper {
    .option-button {
      pointer-events: none;
      color: #9b9aa7;
    }
  }
}
</style>
<style lang="scss">
.lib-manage-wrapper {
  .build-dialog {
    .el-dialog {
      .el-dialog__body {
        label {
          width: 145px;
        }
        .el-input {
          width: 240px;
        }
      }
    }
  }
}
.add-tip {
  .el-dialog {
    .el-dialog__body {
      .dialog-input-container {
        label {
          font-size: 12px;
          color: #515151;
        }
        .el-input {
          width: 250px;
        }
      }
    }
  }
}
</style>
